function Admissions() {
  const classes = [
    "Pre-Nursery",
    "Nursery",
    "L.K.G (PP-I)",
    "U.K.G (PP-II)",
    "Class I to IX",
  ];

  const documents = [
    "Duly filled and signed Application Form",
    "Passport size photographs of the child",
    "Birth Certificate / Aadhar Proof",
    "Transfer Certificate (if applicable)",
    "Previous school report cards",
    "Transport Form (if required)",
  ];

  const ageCriteria = [
    { class: "Pre-Nursery", age: "2 – 3 years" },
    { class: "Nursery", age: "3 – 4 years" },
    { class: "LKG", age: "4 – 5 years" },
    { class: "UKG", age: "5 – 6 years" },
    { class: "Grade I", age: "6 – 7 years" },
    { class: "Grade II", age: " 7 – 8  years" },
    { class: "Grade III", age: " 8– 9 years" },
    { class: "Grade IV", age: " 9–10  years" },
    { class: "Grade v", age: " 10– 11 years" },
    { class: "Grade VI", age: " 11–12  years" },
    { class: "Grade VII", age: " 12–13  years" },
    
  ];

  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">

        {/* Title */}
        <h1 className="text-4xl font-bold text-blue-900 text-center mb-12">
          Admissions
        </h1>

      {/* Download Button */}
    <a
      href="/forms/application-form.pdf"
      download
      className="block text-center bg-yellow-400 hover:bg-yellow-300 text-blue-900 py-4 rounded-xl font-bold text-lg transition duration-300"
    >
      Download PDF Form
    </a>

    {/* View Button */}
    <a
      href="/forms/application.pdf"
      target="_blank"
      rel="noopener noreferrer"
      className="block text-center border-2 border-white hover:bg-white hover:text-blue-900 py-4 rounded-xl font-bold text-lg transition duration-300 mt-4"
    >
      View Application Form
    </a>

        {/* Offering Classes */}
        <div className="bg-white p-8 rounded-2xl shadow mb-10">
          <h2 className="text-2xl font-bold text-yellow-500 mb-6">
            Offering Classes
          </h2>

          <div className="grid md:grid-cols-2 gap-4">
            {classes.map((item, i) => (
              <div key={i} className="bg-gray-100 p-4 rounded-lg">
                {item}
              </div>
            ))}
          </div>
        </div>

        {/* Registration Process */}
        <div className="bg-white p-8 rounded-2xl shadow mb-10">
          <h2 className="text-2xl font-bold text-yellow-500 mb-6">
            Registration Process
          </h2>

            
          <ul className="space-y-3 text-gray-700">
            <li>
              Application form must be filled and submitted within 3 working days.
            </li>
            <li>
              Pre-primary admissions are based on Observation / Interaction.
            </li>
            <li>
              Parents must be present during the interaction.
            </li>
            <li>
              Written test for Classes III to IX.
            </li>
            <li className="text-red-600 font-semibold">
              Incomplete application forms will be rejected.
            </li>
          </ul>
        </div>

        {/* Documents */}
        <div className="bg-white p-8 rounded-2xl shadow mb-10">
          <h2 className="text-2xl font-bold text-yellow-500 mb-6">
            Required Documents
          </h2>

          <ul className="grid md:grid-cols-3 gap-3 text-gray-700">
            {documents.map((doc, i) => (
              <li key={i}>✔ {doc}</li>
            ))}
          </ul>
        </div>

        {/* Age Criteria */}
        <div className="bg-white p-8 rounded-2xl shadow mb-10">
          <h2 className="text-2xl font-bold text-yellow-500 mb-6">
            Age Criteria (2025–2026)
          </h2>

          <div className="grid md:grid-cols-2 gap-4">
            {ageCriteria.map((item, i) => (
              <div key={i} className="bg-gray-100 p-4 rounded-lg">
                <strong>{item.class}</strong>: {item.age}
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <a
            href="mailto:capitolmysuru@gmail.com"
            className="bg-yellow-400 text-blue-900 px-8 py-3 rounded-full font-bold hover:bg-yellow-300 transition"
          >
            Apply via Email
          </a>
        </div>

      </div>
    </section>
  );
}

export default Admissions;